export const SET_ON_BOARDING_STEP = 'SET_ON_BOARDING_STEP'
export const SET_ON_BOARDING_SPORTS = 'SET_ON_BOARDING_SPORTS'
export const SET_USER_SPORT = 'SET_USER_SPORT'
export const SET_USER_SPORT_OBJECT = 'SET_USER_SPORT_OBJECT'
export const SET_SPORT_RELATIONSHIP = 'SET_SPORT_RELATIONSHIP'
export const FETCH_SPORTS_IS_PENDING = 'FETCH_SPORTS_IS_PENDING'
export const SET_ON_BOARDING_PLACE = 'SET_ON_BOARDING_PLACE'
export const SET_ON_BOARDING_BIRTHDAY = 'SET_ON_BOARDING_BIRTHDAY'
export const SET_ON_BOARDING_ACHIEVEMENT_SPORT = 'SET_ON_BOARDING_ACHIEVEMENT_SPORT'
export const SET_ON_BOARDING_ACHIEVEMENT_TEXT = 'SET_ON_BOARDING_ACHIEVEMENT_TEXT'
export const SET_ON_BOARDING_FINISHED = 'SET_ON_BOARDING_FINISHED'

function setOnBoardingStep(state, step) {
    return {
        ...state,
        currentStep: step,
    }
}

function setOnBoardingSports(state, sports) {
    return {
        ...state,
        sports: sports,
    }
}

function fetchSportsIsPending(state, isPending) {
    return {
        ...state,
        fetchSportsIsPending: isPending,
    }
}

function setOnBoardingUserDataItem(state, item, value) {
    return {
        ...state,
        userData: {
            ...state.userData,
            [item]: value,
        },
    }
}

function setOnBoardingFinished(state, finished) {
    return {
        ...state,
        finished: finished,
    }
}

/**
 * Set user sport into store
 *
 * @param {Object} state
 * @param {Object} userSport
 * @return {{userSport: *}}
 */
function setUserSportObject(state, userSport) {
    return {
        ...state,
        userSport: userSport,
    }
}

/**
 * Reducer for on boarding
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function reducer(state = [], action) {
    switch(action.type) {
        case SET_ON_BOARDING_STEP: return setOnBoardingStep(state, action.step)
        case SET_ON_BOARDING_SPORTS: return setOnBoardingSports(state, action.sports)
        case FETCH_SPORTS_IS_PENDING: return fetchSportsIsPending(state, action.isPending)
        case SET_USER_SPORT: return setOnBoardingUserDataItem(state, 'sport', action.userSport)
        case SET_USER_SPORT_OBJECT: return setUserSportObject(state, action.userSport)
        case SET_SPORT_RELATIONSHIP: return setOnBoardingUserDataItem(state, 'relationToSport', action.relationToSport)
        case SET_ON_BOARDING_PLACE: return setOnBoardingUserDataItem(state, 'place', action.place)
        case SET_ON_BOARDING_BIRTHDAY: return setOnBoardingUserDataItem(state, 'birthday', action.date)
        case SET_ON_BOARDING_ACHIEVEMENT_SPORT: return setOnBoardingUserDataItem(state, 'achievementSport', action.sport)
        case SET_ON_BOARDING_ACHIEVEMENT_TEXT: return setOnBoardingUserDataItem(state, 'achievementText', action.text)
        case SET_ON_BOARDING_FINISHED: return setOnBoardingFinished(state, action.finished)
        default: return state
    }
}
